<template>
  <div>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto border-left-info" elevation="2">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">ผู้ประสงค์ขอย้ายเข้าทั้งหมด</div>
                <v-list-item-title class="headline mb-1 font-weight-bold">{{
                  transference_locations.length
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >รายการทั้งหมดในรอบนี้</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-avatar size="60" color="blue lighten-5">
                <v-icon size="35" color="blue">mdi-account-group</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto border-left-success" elevation="2">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4 text--success">
                  ตรงเงื่อนไขรับย้าย
                </div>
                <v-list-item-title
                  class="headline mb-1 font-weight-bold green--text"
                  >{{ stats.match }}</v-list-item-title
                >
                <v-list-item-subtitle>ตรวจสอบตามสาขาวิชา</v-list-item-subtitle>
              </v-list-item-content>
              <v-avatar size="60" color="green lighten-5">
                <v-icon size="35" color="green">mdi-check-decagram</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto border-left-warning" elevation="2">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4 text--orange">ไม่ตรงเงื่อนไข</div>
                <v-list-item-title
                  class="headline mb-1 font-weight-bold orange--text"
                  >{{ stats.notMatch }}</v-list-item-title
                >
                <v-list-item-subtitle>ตรวจสอบตามสาขาวิชา</v-list-item-subtitle>
              </v-list-item-content>
              <v-avatar size="60" color="orange lighten-5">
                <v-icon size="35" color="orange"
                  >mdi-alert-circle-outline</v-icon
                >
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto border-left-primary" elevation="2">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4 text--primary">ดำเนินการแล้ว</div>
                <v-list-item-title
                  class="headline mb-1 font-weight-bold primary--text"
                  >{{ stats.processed }}</v-list-item-title
                >
                <v-list-item-subtitle
                  >ความเห็นคณะกรรมการแล้ว</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-avatar size="60" color="indigo lighten-5">
                <v-icon size="35" color="indigo">mdi-file-check-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-clipboard-account"
        title="ข้อมูลการย้าย สายการสอน ผู้ประสงค์ขอย้ายเข้า"
        color="indigo"
        class="px-5 py-3"
      >
        <v-card-title class="px-0">
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา (ชื่อ, นามสกุล, สังกัด, สาขา)"
                outlined
                dense
                hide-details
                class="rounded-lg"
              />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="auto">
              <v-btn
                color="success"
                class="rounded-lg font-weight-bold"
                @click="exportToExcel"
                :disabled="transference_locations.length === 0"
              >
                <v-icon left>mdi-file-excel</v-icon>
                ส่งออก Excel (xlsx)
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="transference_locations"
          :search="search"
          :items-per-page="25"
          :footer-props="{ 'items-per-page-options': rowsperpage }"
          class="elevation-1 border-top-indigo"
        >
          <template v-slot:item.id_tfp="{ item }">
            {{ item.id_tfp }}
          </template>

          <template v-slot:item.conditionidbranch="{ item }">
            <v-chip
              v-if="item.tlid_branch === item.conditionidbranch"
              color="green lighten-5"
              text-color="green darken-2"
              small
              class="font-weight-bold"
            >
              <v-icon x-small left>mdi-check-circle</v-icon> ตรงเงื่อนไข
            </v-chip>
            <v-chip
              v-else
              color="red lighten-5"
              text-color="red darken-2"
              small
              class="font-weight-bold"
            >
              <v-icon x-small left>mdi-close-circle</v-icon> ไม่ตรงเงื่อนไข
            </v-chip>
          </template>

          <template v-slot:item.documentsLinkfile="{ item }">
            <v-btn
              v-if="item.documentsLinkfile"
              icon
              color="info"
              @click="viewdocumentsLinkfile(item.documentsLinkfile)"
              title="ดูเอกสารคำร้อง"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <span v-else class="caption red--text font-weight-bold"
              >ไม่พบไฟล์</span
            >
          </template>

          <template v-slot:item.tlMcommittee="{ item }">
            <v-chip
              v-if="item.tlMcommittee === 'approp'"
              color="success"
              dark
              label
              small
              @click="select_idPosition(item.id_tfl)"
            >
              เห็นควร
            </v-chip>
            <v-chip
              v-else-if="item.tlMcommittee === 'inapprop'"
              color="orange"
              dark
              label
              small
              @click="select_idPosition(item.id_tfl)"
            >
              ไม่เห็นควร
            </v-chip>
            <v-btn
              v-else
              color="primary"
              small
              outlined
              class="rounded-pill"
              @click.stop="select_idPosition(item.id_tfl)"
            >
              <v-icon left small>mdi-pencil-plus</v-icon> พิจารณา
            </v-btn>
          </template>

          <template v-slot:item.tlMdocumentsLinkfile="{ item }">
            <v-btn
              v-if="item.tlMdocumentsLinkfile"
              icon
              color="success"
              :href="'/HRvecfiles/' + item.tlMdocumentsLinkfile"
              target="_blank"
            >
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <v-icon v-else color="grey lighten-1">mdi-file-hidden</v-icon>
          </template>

          <template v-slot:item.cancelPDF="{ item }">
            <v-btn
              v-if="item.tlMdocumentsLinkfile"
              x-small
              :color="item.tlstatus_transfer === 'cc' ? 'grey' : 'warning'"
              depressed
              class="white--text"
              :disabled="item.tlstatus_transfer === 'cc'"
              @click="cancelPDFSubmit(item.id_tfl)"
            >
              {{
                item.tlstatus_transfer === "cc" ? "รอการยกเลิก" : "ยกเลิกไฟล์"
              }}
            </v-btn>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            text
            class="ma-4"
          >
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
          </v-alert>
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="positiondialog" persistent max-width="700px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar flat color="indigo" dark>
            <v-toolbar-title
              >พิจารณาความเห็นคณะกรรมการสถานศึกษา</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-alert
              border="left"
              colored-border
              color="indigo"
              elevation="1"
              class="mb-4"
            >
              <div class="subtitle-1 font-weight-bold">ข้อมูลผู้ขอเข้าย้าย</div>
              <v-row dense>
                <v-col cols="6"
                  ><strong>ชื่อ-นามสกุล:</strong>
                  {{ transference_locations_id_ref.frist_name }}
                  {{ transference_locations_id_ref.last_name }}</v-col
                >
                <v-col cols="6"
                  ><strong>รหัสบัตรประชาชน:</strong>
                  {{ transference_locations_id_ref.tlid_card }}</v-col
                >
                <v-col cols="12"
                  ><strong>สังกัดเดิม:</strong>
                  {{ transference_locations_id_ref.college_name_now }}</v-col
                >
                <v-col cols="12"
                  ><strong>วุฒิ/สาขา:</strong>
                  {{ transference_locations_id_ref.name_branch }}</v-col
                >
              </v-row>
            </v-alert>

            <v-form ref="updatepositionform" lazy-validation>
              <div class="text-center my-6">
                <h3 class="mb-3">ผลการพิจารณา</h3>
                <v-radio-group
                  v-model="transference_location_location_s.tlMcommittee"
                  row
                  justify="center"
                  :rules="[v => !!v || 'กรุณาเลือกความเห็น']"
                  class="d-inline-block"
                >
                  <v-radio value="approp" color="success">
                    <template v-slot:label
                      ><strong class="success--text">เห็นควร</strong></template
                    >
                  </v-radio>
                  <v-radio value="inapprop" color="warning" class="ml-10">
                    <template v-slot:label
                      ><strong class="warning--text"
                        >ไม่เห็นควร</strong
                      ></template
                    >
                  </v-radio>
                </v-radio-group>
              </div>

              <v-file-input
                v-model="documentsLinkfiles"
                accept=".pdf"
                label="แนบไฟล์ผลการพิจารณา/วาระประชุม (PDF เท่านั้น)"
                outlined
                prepend-icon="mdi-file-pdf-box"
                show-size
                :rules="[v => !!v || 'กรุณาแนบไฟล์ประกอบ']"
                class="rounded-lg"
              ></v-file-input>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-4 bg-light">
            <v-spacer></v-spacer>
            <v-btn text @click="positiondialog = false" class="px-6"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="indigo"
              dark
              class="px-8 rounded-pill"
              @click="updatepositionSubmit()"
            >
              <v-icon left>mdi-content-save</v-icon> ยืนยันผลพิจารณา
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdfdocumentsLinkfileDialog" max-width="90%">
        <v-card>
          <v-toolbar dense flat color="grey darken-3" dark>
            <v-toolbar-title>เอกสารแนบ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="pdfdocumentsLinkfileDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <embed
            :src="'/HRvecfiles/' + pdf_files"
            width="100%"
            height="800px"
            type="application/pdf"
          />
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right>
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
// นำเข้าไลบรารี Excel (ตรวจสอบว่าได้รัน npm install xlsx หรือยัง)
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      valid: true,
      edittransference_locationdialog: false,
      positiondialog: false,
      documentsLinkfiles: null,
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      transference_locations: [],
      edittransference_location: {},
      search: "",
      pagination: {},
      headers: [
        { text: "#", align: "center", value: "id_tfp", sortable: false },
        { text: "รหัสบัตรประชาชน", align: "center", value: "tlid_card" },
        { text: "ชื่อ", align: "left", value: "frist_name" },
        { text: "นามสกุล", align: "left", value: "last_name" },
        { text: "สังกัดเดิม", align: "left", value: "college_name" },
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        {
          text: "เงื่อนไขรับย้าย",
          align: "center",
          value: "conditionidbranch"
        },
        { text: "อายุงาน", align: "center", value: "age_app_time" },
        {
          text: "เอกสารคำร้อง",
          align: "center",
          value: "documentsLinkfile",
          sortable: false
        },
        { text: "ผลพิจารณา", align: "center", value: "tlMcommittee" },
        {
          text: "ไฟล์มติ",
          align: "center",
          value: "tlMdocumentsLinkfile",
          sortable: false
        },
        { text: "จัดการ", align: "center", value: "cancelPDF", sortable: false }
      ],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      periods: [],
      transference_locations_id_ref: [],
      transference_location_location_s: { tlMcommittee: null },
      updatepositions: {},
      data_syslog: {},
      pdf_files: "",
      pdfdocumentsLinkfileDialog: false,
      transference_locationsCc: []
    };
  },

  computed: {
    // คำนวณค่าสถิติสำหรับ Dashboard
    stats() {
      const match = this.transference_locations.filter(
        i => i.tlid_branch === i.conditionidbranch
      ).length;
      const processed = this.transference_locations.filter(i => i.tlMcommittee)
        .length;
      return {
        match: match,
        notMatch: this.transference_locations.length - match,
        processed: processed
      };
    },
    date_today_log() {
      let today = new Date();
      return today.toLocaleString("th-TH");
    }
  },

  async mounted() {
    await this.checkSession();
    await this.periodQuery();
  },

  methods: {
    async checkSession() {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      if (!userSession) this.$router.push("/login");
      let result = await this.$http.post("admin.php", {
        user_name: userSession.user_name,
        provice: "check",
        ApiKey: this.ApiKey
      });
      this.user = result.data;
    },

    async periodQuery() {
      let result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_type: "discuss_teacher"
      });
      this.periods = result_period.data;

      if (this.periods.period_college_enable != "1") {
        Swal.fire({
          icon: "error",
          title: "ยังไม่มีกำหนดการพิจารณาในขณะนี้"
        }).then(() => this.$router.push("/college"));
      } else {
        await this.transference_locationQueryAll();
      }
    },

    async transference_locationQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      try {
        let result = await this.$http.post("transference_location.php", {
          ApiKey: this.ApiKey,
          college_code: userSession.user_name,
          time_s: this.periods.period_college_times,
          year_s: this.periods.period_college_year,
          college_code_Newcheck: "Ok"
        });
        this.transference_locations = result.data;
      } finally {
        this.loading = false;
      }
    },

    async select_idPosition(id_tfl) {
      let result_con = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });
      this.transference_locations_id_ref = result_con.data;
      // Reset form
      this.transference_location_location_s.tlMcommittee =
        result_con.data.tlMcommittee || null;
      this.documentsLinkfiles = null;
      this.positiondialog = true;
    },

    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        await this.sweetAlertLoading();

        let userSession = JSON.parse(sessionStorage.getItem("user"));
        this.updatepositions = {
          ApiKey: this.ApiKey,
          id_tfl: this.transference_locations_id_ref.id_tfl,
          tlMcommittee: this.transference_location_location_s.tlMcommittee
        };

        let uploadStatus = true;
        if (this.documentsLinkfiles) {
          let formData = new FormData();
          let filename = `${this.transference_locations_id_ref.tlid_ref}_${userSession.user_name}_Assessment.pdf`;

          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.documentsLinkfiles);
          formData.append("filename", "../HRvecfiles/" + filename);

          let resUpload = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (resUpload.data.status) {
            this.updatepositions.tlMdocumentsLinkfile = filename;
          } else {
            uploadStatus = false;
          }
        }

        if (uploadStatus) {
          let result = await this.$http.post(
            "transference_location.update.movein.php",
            this.updatepositions
          );
          if (result.data.status) {
            Swal.fire({
              icon: "success",
              title: "บันทึกผลการพิจารณาเรียบร้อย",
              timer: 1500
            });
            await this.logActivity(
              "update",
              this.transference_locations_id_ref.tlid_ref
            );
            this.positiondialog = false;
            await this.transference_locationQueryAll();
          }
        } else {
          Swal.fire({ icon: "error", title: "การอัปโหลดไฟล์ล้มเหลว" });
        }
        Swal.close();
      }
    },

    async cancelPDFSubmit(id_tfl) {
      let result = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });
      let item = result.data;

      Swal.fire({
        title: "ยืนยันการยกเลิกไฟล์แนบ?",
        text: `คุณกำลังยกเลิกเอกสารของ ${item.frist_name} ${item.last_name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยันยกเลิก",
        cancelButtonText: "กลับ"
      }).then(async res => {
        if (res.isConfirmed) {
          item.ApiKey = this.ApiKey;
          item.tlstatus_transfer = "cc";
          await this.$http.post(
            "transference_location.update.movein.php",
            item
          );
          await this.transference_locationQueryAll();
          Swal.fire("สำเร็จ", "ส่งคำขอยกเลิกเรียบร้อย", "success");
        }
      });
    },

    async viewdocumentsLinkfile(file) {
      this.pdf_files = file;
      this.pdfdocumentsLinkfileDialog = true;
    },

    // ฟังก์ชันส่งออก Excel
    exportToExcel() {
      const dataToExport = this.transference_locations.map((item, index) => ({
        ลำดับ: index + 1,
        บัตรประชาชน: item.tlid_card,
        ชื่อ: item.frist_name,
        นามสกุล: item.last_name,
        สังกัดเดิม: item.college_name,
        สาขาวิชา: item.name_branch,
        เงื่อนไข:
          item.tlid_branch === item.conditionidbranch ? "ตรง" : "ไม่ตรง",
        อายุงาน: item.age_app_time,
        ผลพิจารณา:
          item.tlMcommittee === "approp"
            ? "เห็นควร"
            : item.tlMcommittee === "inapprop"
            ? "ไม่เห็นควร"
            : "รอการพิจารณา",
        วันที่ทำรายการ: item.date_time
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "MoveIn_List");
      XLSX.writeFile(
        wb,
        `Report_Transference_MoveIn_${this.periods.period_college_year}.xlsx`
      );
    },

    async logActivity(event, detail) {
      let userSession = JSON.parse(sessionStorage.getItem("user"));
      await this.$http.post("data_syslog.insert.php", {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name,
        event_log: event,
        page_log: "transference_location_movein",
        table_log: "transference_location",
        detail_log: detail,
        date_times: this.date_today_log
      });
    },

    sweetAlertLoading() {
      Swal.fire({
        title: "กำลังประมวลผล...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    }
  }
};
</script>

<style scoped>
.border-left-info {
  border-left: 5px solid #2196f3;
}
.border-left-success {
  border-left: 5px solid #4caf50;
}
.border-left-warning {
  border-left: 5px solid #ff9800;
}
.border-left-primary {
  border-left: 5px solid #3f51b5;
}
.border-top-indigo {
  border-top: 3px solid #3f51b5;
}
.bg-light {
  background-color: #f8f9fa;
}
</style>
